// Simple Element Bridge - Creates missing elements that the customization system expects
// This should be loaded BEFORE the customizer scripts

(function() {
    'use strict';
    
    function createMissingElements() {
        // 1. Create ProductSelect-product-template if it doesn't exist
        if (!document.getElementById('ProductSelect-product-template')) {
            var select = document.createElement('select');
            select.id = 'ProductSelect-product-template';
            select.style.display = 'none';
            
            // Get current variant from the theme
            var currentVariant = document.querySelector('input[name="id"].product-variant-id');
            if (currentVariant) {
                var option = document.createElement('option');
                option.value = currentVariant.value;
                option.selected = true;
                select.appendChild(option);
                
                // Sync with theme variant changes
                var observer = new MutationObserver(function() {
                    select.innerHTML = '';
                    var newOption = document.createElement('option');
                    newOption.value = currentVariant.value;
                    newOption.selected = true;
                    select.appendChild(newOption);
                });
                observer.observe(currentVariant, { attributes: true, attributeFilter: ['value'] });
            }
            
            document.body.appendChild(select);
        }
        
        // 2. Create variant_price element if it doesn't exist
        if (!document.getElementById('variant_price')) {
            var priceDiv = document.createElement('div');
            priceDiv.id = 'variant_price';
            priceDiv.style.display = 'none';
            
            // Get current price
            var priceElement = document.querySelector('price-money .money');
            if (priceElement) {
                priceDiv.textContent = priceElement.textContent;
            }
            
            document.body.appendChild(priceDiv);
        }
        
        // 3. Create get_product_title element if it doesn't exist
        if (!document.querySelector('.get_product_title')) {
            var titleDiv = document.createElement('div');
            titleDiv.className = 'get_product_title';
            titleDiv.style.display = 'none';
            
            var title = document.querySelector('.product__heading');
            if (title) {
                titleDiv.textContent = title.textContent.trim();
            }
            
            document.body.appendChild(titleDiv);
        }
        
        // 4. Create customer_id if it doesn't exist
        if (!document.getElementById('customer_id')) {
            var customerInput = document.createElement('input');
            customerInput.type = 'hidden';
            customerInput.id = 'customer_id';
            customerInput.value = '';
            document.body.appendChild(customerInput);
        }
        
        console.log('Element bridge: Missing elements created');
    }
    
    // Run immediately if DOM is ready, otherwise wait
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', createMissingElements);
    } else {
        createMissingElements();
    }
    
})();